/* Utils */
import { WEB_URL_TO_DISPLAY } from '../../utils/constants';
import { WEB_URL } from '../../utils/env';
import platform from '../../utils/platform';
import { redirectTo } from '../../utils/history';
import { getLink, Routes } from '../../utils/router';

export const MessageId = {
  FRONT_PORCH: 'front-porch',
  LOST_CONNECTION: 'lost-connection',
};

export const MESSAGES = {
  [MessageId.FRONT_PORCH]: {
    title: {
      id: 'info.frontPorchUser.title',
    },
    description: {
      id: 'info.frontPorchUser.description',
      values: {
        span: (chunks) => <span className="dtv-html5-c-full-screen-message__yellow-bold">{chunks}</span>,
        url: WEB_URL_TO_DISPLAY,
      },
    },
    button: {
      id: 'common.back',
    },
    action: () => redirectTo(getLink(Routes.Logout)),
    backgroundImage: `${WEB_URL}/content/dam/ott/lg/frontPorchBG.png`,
  },
  [MessageId.LOST_CONNECTION]: {
    title: {
      id: 'info.lostConnection.title',
    },
    description: {
      id: 'info.lostConnection.description',
    },
    action: platform.sendAppToBackground,
  },
};
